import React, { useEffect, useState } from "react";
import { Card, message, Row, Spin } from "antd";
import Get from "../services/Get";

const YourUpline = () => {
  const [uplineUser, setUplineUser] = useState();
  const [loading, setLoading] = useState(false);

  const parsedUser = JSON.parse(localStorage.getItem("user"));

  const getUplineUser = async () => {
    setLoading(true);
    try {
      const res = await Get.MLMUserDetails(parsedUser.id);
      console.log(res);

      if (res.error && res.error === "Not registered") {
        return;
      }
      if (res.error) {
        message.error(res.error);
      } else {
        setUplineUser(res.data.upline);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUplineUser();
  }, []);

  return (
    <div>
      {loading ? (
        <Row justify={"center"} align={"middle"} style={{ minHeight: '100vh' }}>
          <Spin size="large" />
        </Row>
      ) : (
        <Card className="upline_card">
          <div className="your_upline_box">
            <h3>Your Upline</h3>
            <h5>
              Name : <span>{uplineUser?.name}</span>
            </h5>
            <h5>
              Mobile : <span>{uplineUser?.mobile}</span>
            </h5>
          </div>
        </Card>
      )}
    </div>
  );
};

export default YourUpline;
